import { DatasetStyleColor } from '@infotech-soe/metaschema';
import Color from 'color';
import { validateHTMLColor } from 'validate-color';

import { isEven } from './isEven';

export const applyOddEvenRowStyles = (
  colors: Partial<DatasetStyleColor>,
  rowIndex: number
) => ({
  ...colors,
  ...(validateHTMLColor(colors.backgroundColor ?? '') && {
    backgroundColor: isEven(rowIndex)
      ? Color(colors.backgroundColor).darken(0.09).toString()
      : colors.backgroundColor,
  }),
});
